// extracted by mini-css-extract-plugin
module.exports = {"open":"SharedCompetencyUnitDetail_open__2GY0r","close":"SharedCompetencyUnitDetail_close__38wWn"};